import React from "react";
import { Box, CircularProgress, Typography, useTheme } from "@mui/material";

const LoadingScreen = ({ message = "Cargando..." }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "400px",
        width: "100%",
        gap: 2,
      }}
    >
      <CircularProgress
        size={50}
        thickness={4}
        sx={{
          color: theme.palette.primary.main,
        }}
      />
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{
          fontWeight: 500,
          animation: "pulse 1.5s ease-in-out infinite",
          "@keyframes pulse": {
            "0%, 100%": { opacity: 1 },
            "50%": { opacity: 0.5 },
          },
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingScreen;
